import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { useNavigate } from 'react-router';
import SecundButton from 'components/form/buttons/secundButton';
import TeaboyReasonsTable from './lib/table';

import * as S from './styles';

export default function TeaboyCancelledReasons() {
  const { rejectReasons }: any = useTypedSelector((state) => state.Cafeteria);

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/panel/cafeteria/teaboy-cancelled-reason/create');
  };

  return (
    <S.Container>
      <S.Head>
        <S.Title>Teaboy Cancelled Reasons</S.Title>
        <SecundButton hasIcon={true} onClick={handleRedirect}>
          Create new Reason
        </SecundButton>
      </S.Head>
      <Gap size="20px" />
      <TeaboyReasonsTable menuList={rejectReasons.data} loading={rejectReasons.loading} />
    </S.Container>
  );
}
